import { Card, CardBody, Col } from "reactstrap";
import { RatioTitle } from "../../../constants";
import { AvatarRatioData, RatioSubTitle } from "../../../data/uiKits/Avatars";
import { dynamicImage } from "../../../utils";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const Ratio = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={RatioTitle} span={RatioSubTitle} />
        <CardBody className="avatar-showcase">
          <div className="avatars">
            {AvatarRatioData &&
              AvatarRatioData.map((item, index) => (
                <div className="avatar ratio" key={index}>
                  <Image className={`b-r-8 img-${item.class}`} src={dynamicImage(item.image)} alt="user profile" />
                </div>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Ratio;
